import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import TableOfContents from '../components/table-of-contents';

interface TableOfContentsProcessorElement extends Element {
  props: Element['props'] & {
    querySelector: string;
    includeHeadings: string;
    'data-erom-toc-query-selector': string;
    'data-erom-toc-include-headings': string;
  };
}

const tableOfContents: Processor<TableOfContentsProcessorElement> = {
  priority: 10,
  name: 'tableOfContents',
  test: ({ node }) =>
    !!node.props?.className &&
    node.props.className.includes('wp-block-erom-table-of-contents') &&
    node.props?.hasOwnProperty('data-erom-toc-query-selector') &&
    node.props?.hasOwnProperty('data-erom-toc-include-headings'),
  processor: ({ node }) => {
    node.props.querySelector = node.props['data-erom-toc-query-selector'];
    node.props.includeHeadings = node.props['data-erom-toc-include-headings'];

    node.component = TableOfContents as ComponentType;

    return node;
  }
};

export default tableOfContents;
